import { useEffect, useRef, useState } from 'react';
import SelectDelivery from '../select/SelectDelivery';
import { API_GET, DBRequest, useConfig } from '../../api/api';

// the user ids of a "Users in CC" setting ("[1,2]")
function parseUserIds(value) {
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed.map(Number) : [];
  } catch (e) {
    return [];
  }
}

const StepDelivery = ({
  updateDataCollection,
  dataCollection,
  updateValidation,
  useInvoiceMail,
  recipientKey,
  defaultRecipientMailKey,
  allowMailContent,
  textBlockType,
  ccUsersSetting,
}) => {
  const config = useConfig();

  // The employees of the "Users in CC" setting (offer / order / invoice) are
  // proposed as CC once, before the delivery form is shown, so the author
  // can still remove them. A delivery that already has a CC list (also an
  // emptied one) is left alone.
  const defaultCcIds = parseUserIds(
    ccUsersSetting ? config?.mail?.[ccUsersSetting] : null,
  );
  const needsDefaultCc =
    defaultCcIds.length > 0 && dataCollection.delivery?.cc === undefined;
  const [defaultCcLoading, setDefaultCcLoading] = useState(needsDefaultCc);
  const prefilledRef = useRef(false);

  useEffect(() => {
    if (!needsDefaultCc || !config || prefilledRef.current) return;
    prefilledRef.current = true;
    DBRequest({
      config,
      path: 'users',
      method: API_GET,
      onResponse: (res) => {
        const cc = (res.data || [])
          .filter((user) => defaultCcIds.includes(user.id) && user.email)
          .map((user) => ({
            ...user,
            type: 'employee',
            name: `${user.firstName || ''} ${user.lastName || ''}`.trim(),
            email: user.email,
          }));
        // keep the default delivery type, otherwise the form starts without one
        updateDataCollection({
          delivery: {
            defaultType: 'recipientMail',
            ...(dataCollection.delivery || {}),
            cc,
          },
        });
        setDefaultCcLoading(false);
      },
      onError: () => setDefaultCcLoading(false),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config, needsDefaultCc]);

  function handleDeliverySelect(delivery) {
    updateDataCollection({ delivery: delivery });
  }

  // validation
  useEffect(() => {
    var isValid = true;

    if (!dataCollection.delivery) isValid = false;

    if (
      dataCollection.delivery &&
      !dataCollection.delivery.saveOnly &&
      !dataCollection.delivery.deliveryMail
    )
      isValid = false;

    updateValidation(isValid);
  }, [dataCollection]);

  // the CC field keeps its first value, so it must not mount before the defaults are in
  if (defaultCcLoading) return null;

  return (
    <SelectDelivery
      useInvoiceMail={useInvoiceMail}
      onSelect={handleDeliverySelect}
      recipient={dataCollection[recipientKey || 'recipient']}
      allowCC
      allowMailContent={allowMailContent}
      defaultRecipientMailKey={defaultRecipientMailKey}
      deliveryObj={dataCollection.delivery}
      textBlockType={textBlockType}
    />
  );
};

export default StepDelivery;
